import { env } from "./env";

const config = {
  apiUrl: env.VITE_CORE_API_REST_URL,
  firebaseConfig: {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  },
};

export default config;
